module.exports = __webpack_public_path__ + "img/weixieqingbao.2d171747.png";